<router-outlet></router-outlet>
<div *ngIf="isLoading" class="app-loading"></div>
